import { render, staticRenderFns } from "./FamilyLensSelector.vue?vue&type=template&id=5fc45b13&scoped=true&"
import script from "./FamilyLensSelector.vue?vue&type=script&lang=js&"
export * from "./FamilyLensSelector.vue?vue&type=script&lang=js&"
import style0 from "./FamilyLensSelector.vue?vue&type=style&index=0&id=5fc45b13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc45b13",
  null
  
)

export default component.exports